import { Stack, Typography, IconButton, Box } from "@mui/material";
import { useRouter } from "next/router";
import { CrossIcon } from "@/components/common/icons";
import ConfirmModal from "@/components/common/modals/confirmModal";
import MembershipCardDescription from "@/components/online-store/memberships/membershipCardDescription";
import useMoxieMediaQuery from "@/hooks/misc/useMoxieMediaQuery";
import { MedspaMembership } from "@/views/online-store/onlineStoreView";

export default function MembershipCardMoreDetailsModal({
  membership,
  isModalOpen,
  setIsModalOpen,
  url,
}: {
  membership: MedspaMembership;
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
  url?: string;
}) {
  const { push } = useRouter();
  const isMobile = useMoxieMediaQuery("ipad-ver", "down");

  return (
    <ConfirmModal
      sx={{
        maxWidth: isMobile ? "400px" : "600px",
        "& button": {
          height: "40px !important",
        },
      }}
      isConfirmOpen={isModalOpen}
      discard={() => setIsModalOpen(false)}
      confirm={() => push(url)}
      confirmOptions={{
        confirmButtonText: "Sign up now",
        title: (
          <Stack
            direction="row"
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h3">{membership.title}</Typography>
            <IconButton onClick={() => setIsModalOpen(false)}>
              <CrossIcon />
            </IconButton>
          </Stack>
        ),
        description: (
          <Box sx={{ mt: -1, mb: 3, textAlign: "left" }}>
            <MembershipCardDescription
              membership={membership}
              truncateDescription={false}
              descriptionCustomTextVariant={
                isMobile ? "paragraph" : "paragraphSmall"
              }
              perkCustomTextVariant={isMobile ? "labelDefault" : "labelSmall"}
              sx={{ pb: 2 }}
            />
          </Box>
        ),
      }}
    />
  );
}
